export const getStyles = () => ({
  UrlContainer: {
    width: '435px',

    '& .store-url-text-container': {
      marginBottom: '10px',
    },
  },
  MobileUrlContainer: {
    width: '435px',
    marginTop: '20px',
  },
});
